import { AxiosInstance } from 'axios';

// for multiple requests
let isRefreshing = false;
let failedQueue: {
  resolve: (value?: unknown | PromiseLike<unknown>) => void;
  reject: (reason?: any) => void;
}[] = [];

const removeDuplicatedBaseURL = (config) => {
  // replace baseURL from url
  const { baseURL, url } = config;
  if (baseURL && url) {
    config.url = url.replace(new RegExp(`^${baseURL}`, 'g'), '');
  }
  return config;
};

const processQueue = (error, token: string | null = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
};

const defaultOptions = {
  statusCodes: [401],
  tokenHeaderName: 'Authorization',
};
type Options = typeof defaultOptions;

const authInterceptor = (
  axiosInstance: AxiosInstance,
  refreshAuthCall: (config: any) => Promise<{ token: string }>,
  optionsParams: Partial<Options> = defaultOptions
) => (error) => {
  const _axios = axiosInstance;
  const options = { ...defaultOptions, ...optionsParams };
  const originalRequest = error.config;

  if (
    options.statusCodes.includes(error.response?.status) &&
    !originalRequest._retry
  ) {
    if (isRefreshing) {
      return new Promise(function (resolve, reject) {
        failedQueue.push({ resolve, reject });
      })
        .then((token) => {
          originalRequest.headers[options.tokenHeaderName] = token;
          removeDuplicatedBaseURL(originalRequest);
          return _axios.request(originalRequest);
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    }
    originalRequest._retry = true;
    isRefreshing = true;

    return new Promise((resolve, reject) => {
      refreshAuthCall(originalRequest)
        .then(({ token }) => {
          originalRequest.headers[options.tokenHeaderName] = token;
          removeDuplicatedBaseURL(originalRequest);
          processQueue(null, token);
          resolve(_axios(originalRequest));
        })
        .catch((err) => {
          processQueue(err, null);
          reject(err);
        })
        .then(() => {
          isRefreshing = false;
        });
    });
  }

  return Promise.reject(error);
};

export default authInterceptor;
